import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import { reaction } from 'mobx'
import i18n from 'i18next'
import * as R from 'ramda'
import { mapToQuestion } from './Model/ReportQuestion'
import { toReportPage } from './Model/ReportPage'

import LeftPanel from './components/LeftPanel'
import RightPanel from './components/RightPanel'
import AdvancedXTab from './components/RightPanel/AdvancedXTab/AdvancedXTab'
import ComparisonModal from './components/RightPanel/ComparisonModal'
import BenchmarkingModal from './components/RightPanel/BenchmarkingModal'
import DownloadModal from '../Modals/DownloadModal'
import ReportFilterModal from './components/Modal/Filter'

import './css/report.scss'

import ReportFilter from './ReportFilter'
import ReportStore from './ReportStore'
import AppLoading from '../AppLoading'
import { getAiQuestions } from '../../utils/QuestionHelper'
import ExportModal from './ExportModal'

@observer
class Report extends PureComponent {
    constructor(props) {
        super(props)
        const { store } = props
        const { survey } = store
        const defaultLocale = survey.metadata.locales.includes(store.langcode) ? store.langcode : survey.metadata.defaultLocale
        this.reportStore = new ReportStore(defaultLocale, survey.id, store.tokenData.clientId, store)
        this.reportStore.setYoyComparison()
        if (R.pathOr(false, ['metadata', 'isParent'], survey) && survey.surveyBranches) {
            this.reportStore.setSurveyBranchComparisons()
        }

        this.reportStore.questionMap = new Map()
        this.ReportFilter = new ReportFilter({
            clientId: store.tokenData.clientId,
            surveyId: store.survey.id,
            years: this.reportStore.defaultComparisonSurvey ? [{
                id: this.reportStore.defaultComparisonSurvey.value,
                year: this.reportStore.defaultComparisonSurvey.year,
            }] : [{
                id: '',
                year: 0,
            }],
            langCode: store.survey.metadata.defaultLocale,
            benchmarks: new Map(),
            includeTest: this.reportStore.states.get('test'),
            includeIncomplete: this.reportStore.states.get('incomplete'),
        })
        this.reportStore.reportFilter = this.ReportFilter
        this.userBenchmarks = []
        this.state = {
            loading: true,
            includeTest: false,
            includeIncomplete: false,
            showDebug: false,
            dataUpdated: new Date().getTime(),
            updated: new Date().getTime(),
            fetchingData: false,
        }
        console.log(`toQueryString ${this.ReportFilter.toQueryString()}`)

        reaction(
            () => [this.reportStore.isPageQuestionMapNewReady, this.reportStore.isReportDataReady],
            () => {
                const {
                    isPageQuestionMapNewReady,
                    isReportDataReady,
                    setMaxbiStats,
                    v2ReportData,
                    v2ReportStats,
                } = this.reportStore
                if (survey.isMaxbi() && isReportDataReady && isPageQuestionMapNewReady) {
                    setMaxbiStats(v2ReportData, v2ReportStats)
                }
            },
        )
    }

    setupSurvey = async () => {
        const { store } = this.props
        const { survey } = store
        this.reportStore.pageQuestionMap = new Map()
        let questionUrl = `/api/survey/${survey.id}/questions`
        questionUrl += `?portfolioId=${survey.portfolioId}`
        questionUrl += `&surveyType=${survey.metadata.taxonomy.surveyType}`
        questionUrl += `&respondentType=${survey.metadata.taxonomy.respondentType}`
        questionUrl += `&productType=${survey.metadata.productInfo.industrySpecificInfo.productType}`
        try {
            const questions = await store.http.get(questionUrl)
            console.log('here')
            const pageQuestions = survey.standardPages.reduce((c, st) => {
                st.questions.forEach((pq) => {
                    c[pq.id] = pq
                })
                return c
            }, {})
            console.log('here3')
            store.failedQuestions = []
            const withParentQuestion = []
            questions.forEach((question) => {
                if (question.status !== 'failed') {
                    const h = question.question
                    // switch (question.question.questionTypeCode) {
                    //     case 'CH':
                    //         h = new MultipleChoiceQuestion(question.question)
                    //         break
                    //     case 'CO':
                    //         h = new CountryListQuestion(question.question)
                    //     break
                    //     case 'I':
                    //         h = new NumericQuestion(question.question)
                    //     break
                    //     case 'OD':
                    //         h = new PriorityQuestion(question.question)
                    //     break
                    //     case 'PC':
                    //         h = new PercentageQuestion(question.question)
                    //     break
                    //     case 'RD':
                    //         h = new SingleChoiceQuestion(question.question)
                    //     break
                    //     case 'UV':
                    //         h = new UrlVariableQuestion(question.question)
                    //     case 'TL':
                    //         h = new TextBoxListQuestion(question.question)
                    //     break
                    //     case 'RT':
                    //         h = new RatingQuestion(question.question)
                    //     break
                    //     case 'SB':
                    //         h = new DropdownListQuestion(question.question)
                    //     break
                    //     case 'ST':
                    //         h = new StaticText(question.question)
                    //     break
                    //     case 'TA':
                    //         h = new TextAreaQuestion(question.question)
                    //     break
                    //     case 'TB':
                    //         h = new GridQuestion(question.question)
                    //     break
                    //     case 'TX':
                    //         h = new TextBoxQuestion(question.question)
                    //     break
                    //     case 'SG':
                    //             h = new SmartGridQuestion(question.question)
                    //     break
                    // }
                    // const pageQuestion = pageQuestions[Object.keys(pageQuestions).find(pq => pq.toUpperCase() === question.pageQuestionId.toUpperCase())]
                    // if (pageQuestion) {
                    // console.log(`add pageQuestion ${question.pageQuestionId.toUpperCase()}, parent ${pageQuestion.parentId}`)
                    // if (pageQuestion.parentId) {
                    //     withParentQuestion.push({
                    //         questionId: h.id,
                    //         parentId: pageQuestion.parentId,
                    //         pageQuestionId: pageQuestion.id,
                    //     })
                    //     console.log(withParentQuestion)
                    //     // console.log(JSON.stringify(h))
                    // }
                    // pageQuestion.question = h
                    if (h.questionTypeCode === 'FM') {
                        this.reportStore.questionMap.set(h.id, h)
                        this.reportStore.pageQuestionMap.set(question.pageQuestionId.toUpperCase(), h)
                        this.reportStore.pageQuestionMapNew.set(question.pageQuestionId.toUpperCase(), h)
                        h.optionSet.forEach((o) => {
                            const { pageQuestionId } = question
                            const { id } = o.question
                            const key = `${pageQuestionId.toUpperCase()}|${id.toUpperCase()}`
                            this.reportStore.questionMap.set(o.question.id, o.question)
                            this.reportStore.pageQuestionMap.set(key, o.question)
                            this.reportStore.pageQuestionMapNew.set(key, o.question)
                        })
                    } else {
                        this.reportStore.questionMap.set(h.id, h)
                        this.reportStore.pageQuestionMap.set(question.pageQuestionId.toUpperCase(), h)
                        this.reportStore.pageQuestionMapNew.set(question.pageQuestionId.toUpperCase(), h)
                    }
                    // pageQuestion.isEditable = question.editMode !== 'None'
                    // pageQuestion.modifiable = true
                    // pageQuestion.deletable = !question.surveyMandatory
                    // }
                }
            })
            this.reportStore.isPageQuestionMapNewReady = true
        } catch (e) {
            console.error(`Error loading questions ${e}`)
        }
    }

    async componentDidMount() {
        this.reportStore.isLoading = true
        await Promise.all([
            this.reportStore.getBenchmarks(),
            this.reportStore.getReportData(),
            this.reportStore.getComparison(),
            this.reportStore.getCrossTabs(),
            this.reportStore.getMergeFields(),
            this.reportStore.getEMSurveyUser(),
            this.setupSurvey(),
            this.reportStore.getCampaignList(),
            this.reportStore.getExchangeRates(),
        ])

        await this.reportStore.initReportLoadSummary()

        const { store } = this.props
        await getAiQuestions(store)
        this.newMapping()
        this.reportStore.formatReportData()
        this.reportStore.checkPrepopulated()
        this.reportStore.setFilterStatuses()
        this.reportStore.isLoading = false
        this.reportStore.initialised = true
    }

    componentWillUnmount() {
        clearTimeout(this.reportStore.fetchTimeout)
    }

    async UNSAFE_componentWillReceiveProps(props) {
        const { store } = this.props
        console.log('report componentWillReceiveProps')
        if (this.reportStore && this.reportStore.initialised && store.reloadPage) {
            store.reloadPage = false
            this.reportStore.resetToDefaultFilters()
        }
    }

    newMapping = () => {
        const { store } = this.props
        const { survey } = store

        const reportPages = survey.standardPages.map((sp) => toReportPage(sp))
        this.reportStore.initPageExpand(reportPages)
        this.reportStore.reportPages = reportPages.reduce(({ pages, parentMap }, rp) => {
            rp.questions = rp.questions.map((question) => {
                const { pageQuestionId, parentId, optionSetY } = question
                // console.log(`parent => ${parentId}, ${parentMap.keys()}`)
                const parent = parentId
                    ? parentMap.get(parentId.toUpperCase())
                    : null
                const q = mapToQuestion(pageQuestionId, this.reportStore, parent, optionSetY, question)
                if (q.length === 1) {
                    parentMap.set(pageQuestionId.toUpperCase(), q[0])
                }
                return q
            }).flat()
            pages.push(rp)
            return {
                pages,
                parentMap,
            }
        }, {
            pages: [],
            parentMap: new Map(),
        }).pages
    }

    showLoader = () => {
        const stateCopy = { ...this.state }
        stateCopy.fetchingData = true
        this.setState(stateCopy)
    }

    toggleState = async () => {
        const stateCopy = { ...this.state }
        stateCopy.includeTest = this.ReportFilter.includeTest
        stateCopy.includeIncomplete = this.ReportFilter.includeIncomplete
        console.log(`toggleState ${stateCopy.includeTest}`)
        this.showLoader()
        await this.getReportData()
        const dateTime = new Date().getTime()
        stateCopy.fetchingData = false
        stateCopy.updated = dateTime
        stateCopy.dataUpdated = dateTime
        this.setState(stateCopy)
    }

    filter = async () => {
        const stateCopy = { ...this.state }
        this.showLoader()
        await this.getReportData()
        stateCopy.updated = new Date().getTime()
        stateCopy.dataUpdated = new Date().getTime()
        stateCopy.fetchingData = false
        this.setState(stateCopy)
    }

    render() {
        const { store } = this.props
        const { survey } = store
        const { showBranchBanner } = survey
        const { reportStore } = this
        const { updated, dataUpdated, showDebug } = this.state
        const { showComparison, showBenchmarking } = reportStore

        return (
            <div
                id="surveyReport"
                className={
                    `${process.env.USE_NEW_HEADER_UI ? 'survey-view-wrapper ' : ''} ${showBranchBanner ? 'branching' : ''}`
                }
            >
                {!reportStore.initialised
                    ? (
                        <div style={{
                            height: '500px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'relative',
                            width: '100%',
                        }}
                        >
                            <AppLoading noBg showTypewriter />
                        </div>
                    )
                    : (
                        <>
                            {reportStore.initialised && reportStore.isLoading ? (
                                <div style={{
                                    height: '100%',
                                    width: 'calc(100vw - 460px)',
                                    position: 'fixed',
                                    top: 0,
                                    right: 0,
                                    backgroundColor: '#EBEFF5',
                                    zIndex: 3,
                                }}
                                >
                                    <div style={{
                                        height: '500px',
                                        display: 'flex',
                                        marginTop: '100px',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        position: 'relative',
                                        width: '100%',
                                    }}
                                    >
                                        <AppLoading noBg />
                                        <h2 style={{ marginTop: '175px' }}>
                                            {i18n.t('reports.applyingFilters')}
                                            ...
                                        </h2>
                                    </div>
                                </div>
                            ) : (null)}
                            {reportStore.showAdvancedXTab && (
                                <AdvancedXTab loading={!reportStore.initialised} reportStore={reportStore} store={store} />
                            )}
                            <DownloadModal
                                pageType="report"
                                store={store}
                                reportStore={reportStore}
                            />
                            <ReportFilterModal
                                show={reportStore.showFilters}
                                reportStore={this.reportStore}
                                filters={reportStore.filters}
                                onSave={reportStore.saveFilter}
                                onClose={() => { reportStore.showFilters = false }}
                            />
                            <ComparisonModal
                                reportStore={reportStore}
                                showComparisonSelector={showComparison}
                                toggleComparisonSelector={() => {
                                    reportStore.showComparison = !showComparison
                                }}
                            />
                            <BenchmarkingModal
                                reportStore={reportStore}
                                showBenchmarking={showBenchmarking}
                                toggleShowBenchmarking={() => {
                                    reportStore.showBenchmarking = !showBenchmarking
                                }}
                            />
                            {this.reportStore.showExportModal
                                ? (
                                    <ExportModal
                                        reportStore={this.reportStore}
                                    />
                                )
                                : null}
                            {!this.reportStore.showAdvancedXTab && (
                                // <div style={{ width: '100%' }}>
                                //     <div style={{ position: 'relative', display: 'flex', alignItems: 'flex-start', height: '100%' }}>
                                <>
                                    <LeftPanel
                                        store={store}
                                        reportStore={this.reportStore}
                                    />
                                    <RightPanel
                                        store={store}
                                        loading={!this.reportStore.initialised}
                                        reportFilter={this.ReportFilter}
                                        showDebug={showDebug}
                                        reportData={this.reportData}
                                        locale={this.reportStore.locale}
                                        updated={updated}
                                        reportStore={this.reportStore}
                                        dataUpdated={dataUpdated}
                                    />
                                </>
                                //     </div>
                                // </div>
                            )}
                        </>
                    )}
            </div>
        )
    }
}

export default Report
